var $el, $ps, $up, totalHeight;
$(function() {
  $(".resumeFlou a.bt-link").click(function() {

    totalHeight = 0

    $el = $(this);
    $p  = $el.parent();
    $up = $p.parent();
    $ps = $up.find(".resumeContent");

    // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
    $ps.each(function() {
      totalHeight += $(this).outerHeight();
    });

    $up
      .css({
        // Set height to prevent instant jumpdown when max height is removed
        "height": $up.height(),
        "max-height": 9999
      })
      .animate({
        "height": totalHeight
      });

    // fade out read-more
    $p.fadeOut();

    // prevent jump-down
    return false;

  });
    if($('#fDateStart').length) {
        var yesterday = new Date((new Date()).valueOf()-1000*60*60*24);
        $.extend($.fn.pickadate.defaults, {
            monthsFull: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
            weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            today: 'aujourd\'hui',
            clear: 'effacer',
            close: 'fermer',
            formatSubmit: 'yyyy-mm-dd',
            hiddenSuffix: 'Sub',
            hiddenName: true,
            disable: [
                { from: [1900,1,1], to: yesterday }
            ]
        });


        var from_$input = $('#fDateStart').pickadate({
                format: '!du dd/mm/yyyy'
            }),
            from_picker = from_$input.pickadate('picker')

        var to_$input = $('#fDateEnd').pickadate({
                format: 'au dd/mm/yyyy'
            }),
            to_picker = to_$input.pickadate('picker')

        if ( from_picker.get('value') ) {
            to_picker.set('min', from_picker.get('select'))
        }
        if ( to_picker.get('value') ) {
            //from_picker.set('max', to_picker.get('select'))
        }

        from_picker.on('set', function(event) {
            if ( event.select ) {
                to_picker.set('min', from_picker.get('select'));
                if(from_picker.get('select') > to_picker.get('select')) {
                    to_picker.set('select', null);
                }
                to_picker.set('select', null);
            }
            else if ( 'clear' in event ) {
                to_picker.set('min', false);
            }
        });
        to_picker.on('set', function(event) {
            if ( event.select ) {
                //from_picker.set('max', to_picker.get('select'))
            }
            else if ( 'clear' in event ) {
                //from_picker.set('max', false)
            }
        });
    }
});